/*
 * @Descripttion:
 * @version:
 * @Author: linxi
 * @email: 2194421430@qq.com
 * @Date: 2025-07-15 14:10:47
 * @LastEditors: linxi
 * @LastEditTime: 2025-08-06 11:18:03
 */
import { createAsyncThunk } from '@reduxjs/toolkit'
import _ from 'lodash'
import { sendAsync } from '../../../app/applicationSlice'
import { RootThunkApi } from '../../../app/store'
import {
  PSCRecordListParams,
  getPSCRecordList,
  getTPSCRecordDetail,
  getPSCRecordSubmit,
  getPSCRecordListExport,
  getRemove,
  SubmitParams,
  DetailParams
} from '../../../services/PSCRecordList'

// 列表
export const getPSCRecordListAsync = createAsyncThunk<
  void,
  PSCRecordListParams,
  RootThunkApi<void>
>('PSCRecord/getPSCRecordListAsync', async (params, api) => {
  return sendAsync(getPSCRecordList(params), api)
})

// 详情
export const getPSCRecordDetailAsync = createAsyncThunk<
  void,
  DetailParams,
  RootThunkApi<void>
>('PSCRecord/getTAHManagementDetailAsync', async (params, api) => {
  return sendAsync(getTPSCRecordDetail(params), api)
})

// 保存编辑
export const getPSCRecordSubmitAsync = createAsyncThunk<
  void,
  SubmitParams,
  RootThunkApi<void>
>('PSCRecord/getPSCRecordSubmitAsync', async (params, api) => {
  return sendAsync(getPSCRecordSubmit(params), api)
})

// 删除
export const getRemoveAsync = createAsyncThunk<void, any, RootThunkApi<void>>(
  'PSCRecord/getRemoveAsync',
  async (params, api) => {
    return sendAsync(getRemove(params), api)
  }
)

//导出
export const getPSCRecordListExportAsync = createAsyncThunk<
  void,
  PSCRecordListParams,
  RootThunkApi
>('PSCRecord/getPSCRecordListExportAsync', async (params, api) => {
  return sendAsync(getPSCRecordListExport(params), api)
})
